//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"CurvesToOffset",0,"Section",0],[1,"DividingObjectsList",0,"SelectDisplayableObjectList",0],[0,"EndPoint",1,"Point",0],[0,"IsoparametricDirection",1,0],[0,"OffsetDirection",1,0],[1,"OffsetDistance",0,"Expression",0],[0,"StartPoint",1,"Point",0],[0,"ToolOption",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.SelectDividingObjectBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.SelectDividingObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.SelectDividingObjectBuilder.ToolType = Object.freeze({
    "Object" : "Object", "LineByTwoPoints" : "LineByTwoPoints", "OffsetCurveInFace" : "OffsetCurveInFace", "IsoparametricCurve" : "IsoparametricCurve"});

SPLM.GeometricUtilities.SelectDividingObjectBuilder.IsoparametricDirectionType = Object.freeze({
    "U" : "U", "V" : "V"});

export default SPLM;